export default __webpack_public_path__ + "device_stickup_cam_longfin.fa1709a5.png";